import React from "react";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next/";
import { StyledButton } from "@aureskonnect/react-ui";

import store, {
    setMonetics,
    setSelectedPeripherals,
    setCheckModificationEffect,
} from "../../store";
import { store as useStore } from "../../../../PeripheralConfigure/MoneticPeripheralConfigure/store";
import { store as layoutStore } from "@components/VerticalLayout/store";
import { PERIPHERAL_TYPE_MONETIC } from "@constants/index";

export default function MoneticsActionColumn({
    rowData,
    element,
    dataIsMoneticsUpdated,
}: any) {
    const { t } = useTranslation();
    const { monetics, editedSelectedRows } = useSnapshot(store);
    const { dataTable } = useSnapshot(useStore);
    const { oneShop } = useSnapshot(layoutStore);
    const isMultiAssociate = editedSelectedRows.length > 1;

    const [isSelected, setIsSelected] = React.useState<boolean>(false);

    React.useEffect(() => {
        // Skip pre-selection in multi-association mode: the first selected
        // app's monetic is not what the user wants to associate with the
        // OTHER selected apps. Pre-populating `monetics` here would also
        // trip the save-time guard in PrepheralCardFooter (which blocks
        // any multi-save when `monetics.length > 0`), causing a misleading
        // "cannot associate one payment system with more than one
        // application" toast even when the user did not pick any monetic.
        if (isMultiAssociate) return;

        if (rowData !== undefined) {
            rowData[0].subRows !== undefined &&
                rowData[0].subRows.forEach((el: any) => {
                    if (
                        element.Id === el.id_monetic ||
                        monetics.some((item) => item.Id === element.Id)
                    ) {
                        setMonetics(element);
                        setIsSelected(true);
                    }
                });
        }
        // eslint-disable-next-line
    }, [rowData, dataIsMoneticsUpdated]);

    function isSelectedMonetics() {
        let isSelectedMonetics: any[] = [];
        const moneticsIds = new Set(monetics.map((item) => item.Id));
        dataTable.forEach((element: any) => {
            if (rowData[0].shopId !== element.shopId) return;
            for (const el of element.subRows) {
                const rows = oneShop ? [el] : el.subRows;

                if (!rows) continue;
                for (const row of rows) {
                    if (
                        row.peripheralType === PERIPHERAL_TYPE_MONETIC &&
                        !moneticsIds.has(row.id_monetic)
                    ) {
                        isSelectedMonetics.push(row);
                    }
                }
            }
        });
        return isSelectedMonetics;
    }
    const moneticsList: any[] = isSelectedMonetics();

    const isCurrentSelected = monetics.some((item) => item.Id === element.Id);
    const isAlreadyAssociatedElsewhere = moneticsList.some(
        (item) => item.id_monetic === element.Id
    );
    const currentAppAssociatedId:
        | string
        | undefined = rowData?.[0]?.subRows?.find(
        (el: any) => el.peripheralType === PERIPHERAL_TYPE_MONETIC
    )?.id_monetic;
    const isCurrentAppAssociated = currentAppAssociatedId === element.Id;
    const isDisabled =
        isMultiAssociate ||
        (!isCurrentSelected && monetics.length === 1) ||
        (isAlreadyAssociatedElsewhere && !isCurrentAppAssociated);

    return (
        <StyledButton
            rounded
            outline
            className={`${classnames("button-style-select___clz", {
                "not-allowed-icon__clz": isDisabled,
            })}`}
            variant={isCurrentSelected ? "danger" : "light"}
            onClick={() => {
                if (isDisabled) return;
                setMonetics(element);
                setIsSelected(!isSelected);
                setSelectedPeripherals(element);
                setCheckModificationEffect(true);
            }}
        >
            <span>{isCurrentSelected ? t("Deselect") : t("Select")}</span>
        </StyledButton>
    );
}
